import React, { FC } from 'react';
import { AnimatedShape, Box } from '@altermaind/web/ui';

export const DynamicSurveySkeleton: FC = () => {
  return (
    <Box>
      <AnimatedShape height={10} width='30%' mb='xxs' variant='semiRound' />
      <AnimatedShape height={20} width='100%' variant='semiRound' mb='xxxs' />
      <AnimatedShape height={20} width='60%' variant='semiRound' mb='s' />

      <AnimatedShape height={100} width='100%' variant='semiRound' />
    </Box>
  );
};
